module.exports = __webpack_public_path__ + "h5/img/funv-title1.89b945a3.png";